<div *ngIf="webResource">
    
    <!-- Title -->
    <mat-toolbar *ngIf="webResource.title" class="custom-component-selector-web-resource-title mb-3">
        
        <div class="d-flex flex-row justify-content-center align-items-center h-100 w-100">
            <a class="h-100" *ngIf="webResource.iconPath">
                <img class="custom-component-selector-web-resource-title-icon h-100 p-2 me-1" [src]="webResource.iconPath">
            </a>
            <span>{{ webResource.title }}</span>
        </div>
        
    </mat-toolbar>

    <div *ngFor="let section of webResource.sections" [ngClass]="webResource.customClass">

        <div *ngIf="section.title" class="d-flex flex-row justify-content-center align-items-center custom-component-title">
            <img *ngIf="section.iconPath" class="custom-component-selector-web-section-title-icon h-100 p-2 me-1" [src]="section.iconPath">
            <h3 class="text-center m-0">{{ section.title }}</h3>
        </div>
        
        <div [ngSwitch]="section.webSectionTypeId">

            <!-- HTML -->
            <div *ngSwitchCase="1" [ngClass]="section.customClass">
                <app-html-text [items]="section.items"></app-html-text>
            </div>

            <!-- Text list -->
            <div *ngSwitchCase="2" [ngClass]="section.customClass">
                <app-html-text-list [items]="section.items"></app-html-text-list>
            </div>

            <!-- Cards with top image list -->
            <div *ngSwitchCase="3" [ngClass]="section.customClass">
                <app-cards-top-image-list [items]="section.items"></app-cards-top-image-list>
            </div>

            <!-- Cards with lateral image list -->
            <div *ngSwitchCase="4" [ngClass]="section.customClass">
                <app-cards-lateral-image-list [items]="section.items"></app-cards-lateral-image-list>
            </div>

            <!-- Carousel -->
            <div *ngSwitchCase="5" [ngClass]="section.customClass">
                <app-image-carousel [items]="section.items"></app-image-carousel>
            </div>

            <!-- Faq -->
            <div *ngSwitchCase="6" [ngClass]="section.customClass">
                <app-faq-questions [items]="section.items"></app-faq-questions>
            </div>

            <!-- Video -->
            <div *ngSwitchCase="7" [ngClass]="section.customClass">
                <app-video-frame [items]="section.items"></app-video-frame>
            </div>

        </div>

    </div>

</div>